"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonGhostCompact = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("..");
var ButtonPrimaryCompact_1 = require("./ButtonPrimaryCompact");
var mixins_1 = require("../../../../themes/mixins");
var ButtonGhostCompact = function (props) {
    var responsive = (0, mixins_1.useResponsiveMobileStyles)(props.responsive);
    return (react_1.default.createElement(__1.ButtonGhost, __assign({}, props, { typo: "UI_CAPTION_SEMIBOLD_DF", iconSize: responsive ? 16 : 14, style: __assign(__assign({}, (0, ButtonPrimaryCompact_1.generateCompactButtonStyles)(responsive, props.icon)), props.style) })));
};
exports.ButtonGhostCompact = ButtonGhostCompact;
